import { render, staticRenderFns } from "./TaskSurvey.vue?vue&type=template&id=55d5b5f5&scoped=true&"
import script from "./TaskSurvey.vue?vue&type=script&lang=js&"
export * from "./TaskSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d5b5f5",
  null
  
)

export default component.exports